import DashboardLayout from "./DashboardShell";
import { DASH } from "@/constants/testIds";
import {
  LayoutDashboard, Users, GraduationCap, BookOpen, Layers,
  Megaphone, MessageSquare, Settings, UserPlus, Building2, DoorOpen,
  ClipboardCheck, DollarSign, Award, TrendingUp, FileText, NotebookPen, Bell, FileBarChart,
} from "lucide-react";
import {
  OverviewTab, RegistrationsTab, UsersTab, CoursesTab, ClassesTab,
  MessageApprovalsTab, AnnouncementsAdminTab, SettingsTab,
  BranchesTab, RoomsTab, ManagerAttendanceTab, FeesTab, CertificatesTab,
} from "./manager/tabs";
import { AcademicOverviewTab, ManagerLessonsTab } from "./manager/academic";
import { GradingScaleTab } from "./manager/grading";
import { NotificationsAdminTab, NotificationsInboxTab } from "./manager/comms";
import { ReportsTab } from "./manager/reports";
import { MessagesTab } from "./shared/messages";
import { TeacherHomeworkTab } from "./teacher/tabs";
import { ExamGradesTab, HomeworkGradingTab, ProgressReportsTab } from "./teacher/progress";

export default function ManagerDashboard() {
  const tabs = [
    { key: "overview", label: "Overview", icon: LayoutDashboard, render: () => <OverviewTab /> },
    { key: "academic", label: "Academic Report", icon: TrendingUp, render: () => <AcademicOverviewTab /> },
    { key: "registrations", label: "Registrations", icon: UserPlus, render: () => <RegistrationsTab /> },
    { key: "students", label: "Students", icon: GraduationCap, render: () => <UsersTab role="student" testidPrefix="student" /> },
    { key: "teachers", label: "Teachers", icon: Users, render: () => <UsersTab role="teacher" testidPrefix="teacher" /> },
    { key: "courses", label: "Courses", icon: BookOpen, render: () => <CoursesTab /> },
    { key: "branches", label: "Branches", icon: Building2, render: () => <BranchesTab /> },
    { key: "rooms", label: "Rooms", icon: DoorOpen, render: () => <RoomsTab /> },
    { key: "classes", label: "Classes", icon: Layers, render: () => <ClassesTab /> },
    { key: "attendance", label: "Attendance", icon: ClipboardCheck, render: () => <ManagerAttendanceTab /> },
    { key: "lessons", label: "Lessons", icon: NotebookPen, render: () => <ManagerLessonsTab /> },
    { key: "homework", label: "Homework", icon: GraduationCap, render: () => <TeacherHomeworkTab /> },
    { key: "grading", label: "Homework Grading", icon: FileText, render: () => <HomeworkGradingTab /> },
    { key: "exams", label: "Exams & Grades", icon: Award, render: () => <ExamGradesTab /> },
    { key: "reports", label: "Progress Reports", icon: FileText, render: () => <ProgressReportsTab /> },
    { key: "grading-scale", label: "Grading Scale", icon: Award, render: () => <GradingScaleTab /> },
    { key: "fees", label: "Fees", icon: DollarSign, render: () => <FeesTab /> },
    { key: "certificates", label: "Certificates", icon: Award, render: () => <CertificatesTab /> },
    { key: "messages", label: "Message approvals", icon: MessageSquare, render: () => <MessageApprovalsTab /> },
    { key: "inbox", label: "Messages", icon: MessageSquare, render: () => <MessagesTab role="manager" /> },
    { key: "data-reports", label: "Reports", icon: FileBarChart, render: () => <ReportsTab /> },
    { key: "announcements", label: "Announcements", icon: Megaphone, render: () => <AnnouncementsAdminTab /> },
    { key: "notifications", label: "Notifications", icon: Bell, render: () => <NotificationsAdminTab /> },
    { key: "my-notifications", label: "My Notifications", icon: Bell, render: () => <NotificationsInboxTab /> },
    { key: "settings", label: "Settings", icon: Settings, render: () => <SettingsTab /> },
  ];
  return <DashboardLayout role="Manager" testid={DASH.managerRoot} tabs={tabs} />;
}
